module.exports = __webpack_public_path__ + "img/03.d06404d3.webp";